import {
  filterK8Grades,
  sortGradesWithKFirst,
} from 'experienceComponents/CreateInstanceShared/dataUtils'
import {
  getRelevantCourseListForCourse,
  convertGradeNameToLabel,
  getProgramName,
  createViewClassBehavior,
} from './data'

// Filter and sort configuration
export const courseFilterConfig = {
  filterFunction: filterK8Grades,
  sortFunction: sortGradesWithKFirst,
  getRelevantCourseList: getRelevantCourseListForCourse,
}

// Program mapping configuration
export const courseProgramConfig = {
  convertGradeNameToLabel: convertGradeNameToLabel,
  getProgramName: getProgramName,
}

// View class behavior configuration
export const courseViewClassConfig = {
  createViewClassBehavior: createViewClassBehavior,
}

// Legacy config for backward compatibility
export const courseConfig = {
  ...courseFilterConfig,
  ...courseProgramConfig,
  ...courseViewClassConfig,
}
